<template>
  <div class="container-fluid" style="padding:0;overflow-x:hidden">
    <div class="row g-1"> 
      <div class="col-md-8" style="height: 640px">
        <div class="row g-1">
          <div class="col-md-6" style="height:320px">
             <ReportStat :swapid="$store.getters.controllerid" />
          </div>
          <div class="col-md-6" style="height:320px">
             <BarChart globid="BARCHART15" ref="BARCHART15" />
          </div>
        </div>
        <div class="row g-1">
            <div class="col-md-12" style="height:320px">
              <LineGraph ref="LINEGRAPH01" globid="LINEGRAPH01" swapid="ALL"/>
            </div>
        </div>
      </div>
      <div class="col-md-4" style="height: 640px">
        <ReportData ref="REPORTDATA01" :swapid="$store.getters.controllerid"/>
      </div>
    </div>
  </div>
</template>

<script>
import LineGraph from './LineGraph.vue'
import ReportStat from './ReportStat.vue'
import ReportData from './ReportData.vue'
import BarChart from './BarChart.vue'

export default {
  name: 'ReportScreen',
  components: {
      LineGraph, ReportStat, ReportData, BarChart
  },
  data() {
      return {
         filepath : ''
      }
  },
  methods: {
    drawgraph(ginfo, data) {
      let copytab = JSON.parse(JSON.stringify(data.tab)) ;
      if (ginfo.graph == "BAR" || ginfo.graph == "PIE") {
        this.$refs.BARCHART15.drawbar(copytab, ginfo) ;
        let colortab = this.$refs.BARCHART15.colors ;
        this.$refs.REPORTDATA01.writedata(data, colortab) ; 
      }
      else {
        this.$refs.LINEGRAPH01.initdraw(copytab, ginfo) ;
        this.$refs.REPORTDATA01.writedata(data, []) ; 
      }
    }
  },
  props: {
    swapid : String 
  },
}
// vim:expandtab:smartindent:tabstop=2:softtabstop=2:shiftwidth=2:
</script>
